// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { systemBuilderRelatedProductsModalStyles } from "@plumberssupply/App/Components/SystemBuilder/SystemBuilderRelatedProductsModal";
import IconModalClose from "@plumberssupply/XDL/Icons/IconModalClose";
import { color, xScreen } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

systemBuilderRelatedProductsModalStyles.loadMoreButton = {
    css: css`
        display: flex;
        justify-content: center;
        margin-top: 24px;
    `,
};
systemBuilderRelatedProductsModalStyles.modal = {
    size: 1078,
    mergeCss: true,
    cssOverrides: {
        modalTitle: css`
            justify-content: center;
            padding-bottom: 4px;
        `,
        modalBody: css`
            && {
                margin-top: 100px;
                ${xScreen("lte", "md")} {
                    width: 352px;
                    margin: 15px;
                }
            }
        `,
        modalContent: css`
            padding: 16px;
            padding-top: 0;
            // Force GPU Acceleration (fixes paint issues)
            transform: translateZ(0);
        `,
    },
    closeButtonProps: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            right: 0;
            margin: 0;
            width: 38px;
            height: 38px;
            min-height: initial;
            padding: 0;
            border: 0;
            box-shadow: none;
            z-index: 1;

            & > ${IconWrapper} {
                position: unset;
                top: 0;
                &,
                svg {
                    color: ${color("common.ui9")};
                }
            }

            &&:hover {
                border: 0;
                ${IconWrapper}, svg {
                    color: ${color("common.ui1")};
                }
            }
            &&&:hover,
            &&&:focus,
            &&& {
                background: unset;
            }
        `,
    },
    closeButtonIconProps: {
        mergeCss: true,
        size: 14,
        color: "common.ui9",
        src: IconModalClose,
    },
};
systemBuilderRelatedProductsModalStyles.container = {
    css: css`
        min-height: 150px;
    `,
};
systemBuilderRelatedProductsModalStyles.itemsGridContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
    `,
};

systemBuilderRelatedProductsModalStyles.gridItem = {
    css: css`
        padding-block: 16px;
        width: calc(33.3% - 11px);
        border-bottom: 1px solid ${color("common.ui7")};

        &.noBorder {
            border-bottom: none;
        }

        ${xScreen("lte", "md")} {
            width: calc(50% - 8px);
        }

        &:empty {
            display: none;
        }
    `,
};
